<template>
  <el-dialog
    :title="$t('langcfg.txtZernikeSettings')"
    :visible.sync="visible"
    :width="isDE ? '27%' : '20%'"
    @opend="handleOpen"
  >
    <el-row>
      <el-col :span="10">
        <div class="label-div">{{ $t("langcfg.txtOrder") }}:</div>
      </el-col>
      <el-col :span="11">
        <el-input-number
          v-model="zernikeSetUI.order"
          ref="order"
          data-name="order"
          :min="2"
          :max="8"
          :precision="0"
          :step="1"
          :label="'Order'"
        ></el-input-number>
      </el-col>
    </el-row>
    <br />
    <el-row>
      <el-col :span="10">
        <div class="label-div">{{ $t("langcfg.txtDiameter") }}:</div>
      </el-col>
      <el-col :span="11">
        <el-input-number
          v-model="zernikeSetUI.diameter"
          ref="diameter"
          data-name="diameter"
          :min="2"
          :max="12"
          :precision="0"
          :step="1"
          :label="'Order'"
        ></el-input-number>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="hideDialog('OK')" class="btn-operator">{{
        $t("langcfg.txtOK")
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import EVENTS from "../../../bus";
import { isDefined, objectCopy } from "../../../shared/utils";
let timeoutLoading;
export default {
  name: "ZernikeSettings",
  data() {
    return {
      visible: false,
      // order: 8,
      // diameter: 4,
      formLabelWidth: "100px",
      zernikeSetUI: {},
      isDE: false
    };
  },
  mounted() {},
  updated() {
    this.isDE = window.settings.language === "de";
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isVisible: function () {
      this.visible = this.isVisible;
      if (this.isVisible) {
        this.zernikeSetUI = objectCopy(this.zernikeSet);
        let arr = ["diameter", "order"];

        this.$nextTick(() => {
          for (let id in arr) {
            let item = this.$refs[arr[id]];

            if (!isDefined(item)) {
              continue;
            }
            if (this.isVisible) {
              item.$children[0].$el.addEventListener("touchend", (e) => {
                e.preventDefault();
                e.stopPropagation();
                let key = e.target.parentNode.parentNode.getAttribute("data-name");
                this.$bus.$emit(EVENTS.spreadKeyBoard, this.zernikeSetUI[key], (value) => {
                  this.zernikeSetUI[key] = parseFloat(value);
                });
              });
              item.$children[0].$el.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                let key = e.target.parentNode.parentNode.getAttribute("data-name");
                this.$bus.$emit(EVENTS.spreadKeyBoard, this.zernikeSetUI[key], (value) => {
                  this.zernikeSetUI[key] = parseFloat(value);
                });
              });
            } else {
              item.$children[0].$el.removeAllListeners();
            }
          }
        });
      }
    },
    visible: function () {
      this.$emit("update:isVisible", this.visible);
    }
  },
  computed: {
    ...mapGetters(["zernikeSet"])
  },
  methods: {
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.zernikeSetUI[key], (value) => {
        self.zernikeSetUI[key] = value;
      });
    },
    ...mapActions({
      zernikeSetChanged: "topography/zernikeSetChanged"
    }),
    saveSettings() {
      this.zernikeSetChanged(this.zernikeSetUI);
    },
    handleOpen() {},
    showLoading() {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
      clearTimeout(timeoutLoading);
      timeoutLoading = setTimeout(() => {
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }, 5000);
    },
    hideDialog() {
      this.visible = false;
      this.showLoading();
      setTimeout(() => {
        this.saveSettings();
      }, 100);
      // this.$emit('update:isVisible', false)
    }
  }
};
</script>
<style lang="less" scoped>
.label-div {
  color: white;
  font-size: 30px;
  margin: 0px;
  padding: 0px;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
input {
  font-size: 20px;
  width: 100%;
}
.el-input-number /deep/ .el-input__inner {
  font-size: 30px;
}

.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}

.btn-operator {
  border: 1px gray solid;
  height: @header-fs+30px;
  width: 200px;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/topography/pages/dialog-forms/ZernikeSetting.vue